<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0"> Add Subject and Grade</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <CCol sm="12" class="float-right text-right mt-3">
        <br />
        <span @click="GoToPageFindTutor"
          ><img src="../assets/img/iconInboxTeacher.png" width="40px" /> <br /><span
            class="mr-1"
            ></span
          ></span
        >
      </CCol>
      <div class="mt-5"><br /><br /><br /><br /><br /></div>
    </div>
    <CCard
      style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px"
      class="custom-card h-100 full-height"
    >
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
                  Add Subject and Grade
                </h5>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0 mt-2">
                      <CCol sm="12" lg="12">
                        <CRow>
                          <CCol sm="12" lg="12">
                             <div class="text-left">Subject</div>
                            <v-select
                            class="mt-2"
                              v-model="SelectedSubject"
                              :options="subjects"
                              label="SubjectName"
                              placeholder="--Please Select Subject--"
                              required
                            ></v-select>
                          </CCol>
                          <CCol sm="12" lg="12" class="mt-2">
                             <div class="text-left">  Grade</div>
                           <v-select
                            class="mt-2"
                              v-model="SelectedGrade"
                              :options="grades"
                              label="GradeName"
                              placeholder="--Please Select Grade--"
                              required
                            ></v-select>
                          </CCol>
                        </CRow>
                        <div class="mt-3 float-left">
                         <CButton
                          color="success"
                          class="ml-2 mr-2"
                          @click="NewSubject"
                          >Add</CButton
                        >

                          <CButton
                          color="danger"
                          class=" ml-2 mr-2"
                           @click="RemoveSubject"
                          >Remove</CButton
                        >
                        </div>
                       
                        <br />
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
    <CModal
      title="Success"
      size="sm"
      color="success"
      :show.sync="successModal"
    >
      <h5 class="text-center">You have successfully add class and grade</h5>
    </CModal>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      lgs: [],
      se: [],
      ti: [],
      students: [],
      subjects: [],
      grades: [],
      parents: {},
      SelectedSubject: "",
      SelectedGrade: "",
      SelectedStudents: "",
      list: [],
      FilterList: [],

      SearchQuery: "",
      Busy: false,

      subjectsOptions: [],
      Success: false,

      TuitionCenterCode: "",
      Age: "",
      ParentName: "",
      Age: "",
      gender: "",
      MainContactNumber: "",
      FullName: "",
      successModal: false,
    };
  },
  async mounted() {
    this.GetSubject();
    this.GetGrade();
    this.GetParentDetail();
  },
  computed: {
    TuitionCenterCode: {
      get: function () {
        let tc = "2075";
        return tc;
      },
    },
  },
  methods: {
    async RefreshModal() {
      this.successModal = false;
    },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.lgs = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetParentDetail() {
      this.$API
        .get(this.$DetailParent + "?userID=" + this.$route.query.userID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.se = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.ti = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetListOfTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
            this.getPic(this.FilterList.PicturePath);
          }
        });
    },
    getPic(index) {
      return "https://pickiddo.com/" + this.FilterList[index].PicturePath;
    },
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },

    ApplyFilter: function () {
      var arr = _.orderBy(this.list, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilterList = result;
      }
    },
    FilterListSubject() {
      console.log("testing");
      this.FilterList = this.list;

      if (this.SelectedSubject !== "ALL SUBJECT")
        this.FilterList = _.filter(
          this.FilterList,
          (item) =>
            item.TeachingSubjectList[0].Name ===
            this.SelectedSubject.SubjectName
        );
      console.log("t" + this.SelectedSubject.SubjectName);
    },

    FilterListGrade() {
      console.log("testing");
      this.FilterList = this.list;

      if (this.SelectedGrade !== "ALL GRADE")
        this.FilterList = _.filter(
          this.FilterList,
          (item) => item.GradeList[0].Name === this.SelectedGrade.GradeName
        );
    },
    async OpenSuccess() {
      this.successModal = true;
    },
     NewSubject() {
      const formData = new FormData();

      formData.append("TeacherId", this.$route.query.userId);
      formData.append("Content", this.SelectedSubject.SubjectName);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("ContentGrade", this.SelectedGrade.GradeName);

      return this.$API
        .post(this.$TeacherAddNewSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null && response.data > 0) {
              this.GoToPageHome();
          }
          else{
                this.errorModal = true;

          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },

      RemoveSubject() {
      const formData = new FormData();

      formData.append("TeacherId", this.$route.query.userId);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);

      return this.$API
        .post(this.$TeacherDeleteSubject, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null && response.data > 0) {
            
             this.GoToPageHome();
          }
          else{
                this.errorModal = true;

          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  
    GoToPageFindTutor() {
      this.$router.push("/FindSubject?userID=" + this.$route.query.userID);
    },
    GoToRegisterPage() {
      this.$router.push("/RegisterStudent?userID=" + this.$route.query.userID);
    },
      GoToPageHome() {
      this.$router.push("/ProfessionalProfile?userId=" + this.$route.query.userId);
    },
  },
};
</script>
